import { useMemo } from 'react';

export const useEditorFullPageExperiments = (): {
	'table-selector': boolean;
	'macro-interaction-updates': boolean;
	'table-with-fixed-column-widths-option': boolean;
	'more-elements-in-quick-insert-view': boolean;
} => {
	// IMPORTANT: If you add a new feature flag here, please make sure to add it to the
	// `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
	return useMemo(
		() => ({
			'table-selector': true,
			'macro-interaction-updates': true,
			'table-with-fixed-column-widths-option': true,
			'more-elements-in-quick-insert-view': true,
		}),
		[],
	);
};
